module.exports = __webpack_public_path__ + "static/media/contact_ilustration.69beafe2.svg";